import { render, staticRenderFns } from "./UploadVideosDialog.vue?vue&type=template&id=e78067bc&scoped=true"
import script from "./UploadVideosDialog.vue?vue&type=script&lang=js"
export * from "./UploadVideosDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadVideosDialog.vue?vue&type=style&index=0&id=e78067bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78067bc",
  null
  
)

export default component.exports